/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	'use strict';
	/*globals Tc, doT, SCS, require */
	/*jshint smarttabs:true */
	var RES_SORT = ['internet', 'tv', 'voip', 'mobile'];
	var SME_SORT = ['internet', 'service', 'voip', 'tv', 'mobile'];
	var flavourSizeFromSiebelId = require('lib/generic/api/map').flavourSizeFromSiebelId;
	var makePrice = require('lib/ecommerce/Price').default;
	/**
	 * PricedBundleTitle module implementation.
	 *
	 * @author Stefan Maurer
	 * @namespace Tc.Module
	 * @class PricedBundleTitle
	 * @extends Tc.Module
	 */
	Tc.Module.PricedBundleTitle = Tc.Module.extend({

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			this.isLegoMode = this.$ctx.data('is-lego-mode');
			if(this.isLegoMode) {
				var pageSegment = $('body').data('page-segment');
				var $ctx = this.$ctx;
				this.sort = (pageSegment === 'res' ? RES_SORT : SME_SORT).map(function(offer) {
					return {
						key: offer,
						i18n: $ctx.data(offer)
					};
				});
				this.sandbox.subscribe('LEGO_CONTAINER', this);
				this.fire('getBundleTotalPrice', ['LEGO_CONTAINER']);
			}


			callback();
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method after
		 * @param {Function} callback function
		 * @return void
		 */
		after: function () {
			if(!this.isLegoMode) {
				this.fire('PriceAdded', {}, ['formpriceupdate']);
			}
		},

		onBundleTotalPrice: function (data) {
			var titles = [];

			if(Object.keys(data.selectedFlavours).length > 1) {
				$.each(this.sort,function (index, item) {
					var key = item.key;
					if(data.selectedFlavours[key]) {
						var siebelId = data.selectedFlavours[key].slideId;
						var isServiceDisabled = (siebelId === data.disabledValues['tv-disable'] || siebelId === data.disabledValues['voip-disable'] || siebelId === data.disabledValues['mobile-disable']);
						if(!isServiceDisabled) {
							if(key === 'mobile' && data.mobileConfig) {
								siebelId = $.map(data.mobileConfig, function(val) {
									return val.siebelId === siebelId ? val.siebelName : null;
								})[0] || siebelId;
							}
							var flavourSize = flavourSizeFromSiebelId(siebelId);
							titles.push(item.i18n + ' ' + (key === 'mobile' ? flavourSize : flavourSize.toUpperCase()));
						}
					}
				});
				var inputLabel = this.$ctx.find('.prices input').attr('data-label') + '\n' + titles.join(', ');
				this.$ctx.find('.prices input').val(data.totalPrice).data('price', data.totalPrice).attr('data-price', data.totalPrice).attr('data-label', inputLabel).data('label', inputLabel);
				this.$ctx.find('.price').text(makePrice(data.totalPrice).formatted());
				this.fire('PriceAdded', {}, ['formpriceupdate']);
			}
		}

	});
})(Tc.$);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.PricedBundleTitle.js
// module id = 250
// module chunks = 0